// Matches the element height to an element from the dom, which id equals to the ref input
//
// Example:
// <div class="container">
//    <div id="elementToResize"></div>
//    <div [validate]="'elementToResize'"></div>
// </div>
//

import {
  Input,
  Directive,
  ElementRef,
  SimpleChanges,
  Inject,
} from '@angular/core';
import { OnChanges } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Directive({ selector: '[validate]' })
export class ValidateDirective implements OnChanges {
  @Input('validate') validationErrors: Array<any>;

  private dom: Document;

  constructor(
    @Inject(DOCUMENT) dom: any,
    private el: ElementRef,
    private translate: TranslateService
  ) {
    this.dom = dom;
  }

  ngOnChanges(val: SimpleChanges): void {
    const previousErrors = this.el.nativeElement.getElementsByClassName(
      'invalid-error'
    );
    for (let j = previousErrors.length - 1; j >= 0; j--) {
      previousErrors[j].remove();
    }

    const previousElements = this.el.nativeElement.getElementsByClassName(
      'ng-invalid'
    );
    for (let k = previousElements.length - 1; k >= 0; k--) {
      previousElements[k].className = previousElements[k].className.replace(
        'ng-invalid',
        ''
      );
    }

    if (this.validationErrors) {
      for (const error of this.validationErrors) {
        const element = this.el.nativeElement.querySelectorAll(
          `[name="${error.field}"]`
        )[0];
        if (element) {
          const errorSpan = this.dom.createElement('span');
          errorSpan.className = 'invalid-error';
          errorSpan.innerText = this.translate.instant(error.message);

          element.parentNode.appendChild(errorSpan);

          element.className = `${element.className} ng-invalid`;
        }
      }
    }
  }
}
